import React from 'react'
import { borderColor } from "../utils/colors"

export default function Stages({ recipe, activeStage }) {
  return (
    <>
      <p>Stages</p>
      {
        recipe.stages
          // .sort((a, b) => b.id - a.id)
          .map((item, index) => {
            return item.id === activeStage ? (
              <div
                key={index}
                style={{
                  border: "2px solid white",
                  width: "200px",
                  height: "25px",
                  marginTop: 8,
                  fontSize: 20,
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                <p
                  style={{
                    textAlign: "left",
                    margin: 0,
                    marginLeft: 5,
                    color: "white",
                  }}
                >
                  {item.id + 1}
                </p>
                <div
                  style={{
                    border: "1px  solid white",
                    width: "150px",
                    height: "1px",
                    backgroundColor: "white",
                  }}
                ></div>
              </div>
            ) : (
              <div
                key={index}
                style={{
                  border: `2px solid ${borderColor}`,
                  width: "200px",
                  height: "25px",
                  marginTop: 8,
                  fontSize: 20,
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                <p
                  style={{
                    textAlign: "left",
                    margin: 0,
                    marginLeft: 5,
                    color: "#737374",
                  }}
                >
                  {item.id + 1}
                </p>
                <div
                  style={{
                    border: "1px  solid #737374",
                    width: "150px",
                    height: "1px",
                    backgroundColor: "#737374",
                  }}
                ></div>
              </div>
            );
          })
      }
    </>
  )
}